<template>
  <div style="border-radius: 6px; padding: 8px 8px 8px 4px;">
    <Doughnut :chart-options="chartOptions" :chart-data="chartData" :chart-id="chartId" :dataset-id-key="datasetIdKey"
      style="height: 250px" />
  </div>
</template>

<script>
import { Doughnut } from 'vue-chartjs/legacy'

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  ArcElement,
  CategoryScale
} from 'chart.js'

ChartJS.register(Title, Tooltip, Legend, ArcElement, CategoryScale)

export default {
  name: 'DoughnutChart',
  components: {
    Doughnut
  },
  props: {
    chartId: {
      type: String,
      default: 'doughnut-chart'
    },
    datasetIdKey: {
      type: String,
      default: 'label'
    },
    chartData: {
      type: Object,
      default: () => ({ labels: [], datasets: [] })
    },
    title: {
      type: String,
      default: ''
    }
  },
  computed: {
    chartOptions() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            position: 'bottom'
          },
          tooltip: {
            backgroundColor: '#FFFFFF',
            borderColor: '#C5C5C5',
            borderWidth: 0.5,
            titleColor: 'rgba(0, 0, 0, 0.5)',
            titleFont: {
              size: 8,
              lineHeight: 1.5,
              weight: 500,
            },
            bodyFont: {
              size: 8,
              lineHeight: 1,
              weight: 500
            },
            callbacks: {
              title: function (tooltipItems) {
                return tooltipItems[0].label;
              },
              afterTitle: function (tooltipItems) {
                let percentage = ((tooltipItems[0].formattedValue / tooltipItems[0].dataset.data.reduce((a, b) => a + b, 0)) * 100).toFixed(1);
                return `${tooltipItems[0].formattedValue} ${tooltipItems[0].dataset.title} (${percentage}%)`;
              },
              label: function () {
                return null;
              }
            }
          },
          title: {
            display: true,
            text: this.title,
          }
        }
      }
    }
  }
}
</script>
